import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ALL_TYPE_KEY, CONTENTFUL_TYPES } from 'helpers/contentfulTypes';

import { Container, Fieldset, Label, Radio } from 'components/FiltersStyles';

const TabbedFilters = ({ setPageFilter }) => {
  const [pageChecked] = useState(ALL_TYPE_KEY);
  const handleChange = e => {
    if (e.target.checked) {
      setPageFilter(e.target.id);
    }
  };

  return (
    <Container>
      {Object.keys(CONTENTFUL_TYPES).map(contentfulType => {
        const { menuText } = CONTENTFUL_TYPES[contentfulType];
        return (
          <Fieldset key={contentfulType}>
            <Radio
              defaultChecked={contentfulType === pageChecked}
              id={contentfulType}
              name="contentfulType"
              type="radio"
              onChange={e => handleChange(e)}
            />
            <Label htmlFor={contentfulType}>{menuText}</Label>
          </Fieldset>
        );
      })}
    </Container>
  );
};

TabbedFilters.propTypes = {
  setPageFilter: PropTypes.func.isRequired,
};

export default TabbedFilters;
